declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined;

let initialized = false;

export function initGA4() {
  if (initialized || !GA_MEASUREMENT_ID) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function (...args: any[]) {
    window.dataLayer.push(args);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, {
    send_page_view: false,
  });

  initialized = true;
}

export function trackPageView(path: string, title?: string) {
  if (GA_MEASUREMENT_ID && initialized) {
    window.gtag("event", "page_view", {
      page_path: path,
      page_title: title || document.title,
    });
  }
  trackServerEvent("page_view", { path });
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (GA_MEASUREMENT_ID && initialized) {
    window.gtag("event", eventName, params);
  }
  trackServerEvent(eventName, params);
}

export function trackSalvation() {
  trackEvent("salvation_decision", { category: "conversion", label: "user_saved" });
}

export function trackChatMessage(mode?: string) {
  trackEvent("chat_message_sent", { category: "engagement", response_mode: mode });
}

export function trackQAVote(questionKey: string, optionKey: string) {
  trackEvent("qa_vote", { category: "engagement", question: questionKey, option: optionKey });
}

export function trackPrayerStarted() {
  trackEvent("prayer_started", { category: "conversion", label: "prayer_of_salvation" });
}

export function trackFileUpload(fileType: string) {
  trackEvent("file_upload", { category: "engagement", file_type: fileType });
}

function trackServerEvent(eventName: string, params?: Record<string, any>) {
  fetch("/api/analytics/event", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ event: eventName, params, timestamp: Date.now() }),
  }).catch((e) => console.warn("[Analytics] Event send failed:", e));
}
